import * as React from 'react'

function SvgIt(props) {
	return (
		<svg viewBox="0 0 3 2" width="1em" height="1em" {...props}>
			<path fill="#009246" d="M0 0h1v2H0z" />
			<path fill="#fff" d="M1 0h1v2H1z" />
			<path fill="#ce2b37" d="M2 0h1v2H2z" />
		</svg>
	)
}

export default SvgIt
